import { EVENTS, States, eventStream } from '~/components/authentication/locationsmart';

export enum LocationVerificationStatus {
	PENDING = 'PENDING',
	ALLOWED = 'ALLOWED',
	DENIED = 'DENIED',
	ERROR = 'ERROR'
}

type UpdateHandlerParams = {
	status: States;
	data: { error: boolean; denied: boolean };
};

let updateCallback: ((params: UpdateHandlerParams) => void) | null = null;

export const startLocationSmart = (onComplete: (status: LocationVerificationStatus) => void) => {
	if (updateCallback) {
		eventStream.off(EVENTS.update, updateCallback as unknown as () => void);
	} else {
		eventStream.emit(EVENTS.init);
	}

	updateCallback = ({ status, data: { error, denied } }) => {
		if (status !== States.complete) {
			return;
		}

		eventStream.emit(EVENTS.stop);

		if (!error && !denied) {
			onComplete(LocationVerificationStatus.ALLOWED);
		} else if (denied) {
			onComplete(LocationVerificationStatus.DENIED);
		} else {
			onComplete(LocationVerificationStatus.ERROR);
		}
	};

	eventStream.on(EVENTS.update, updateCallback as unknown as () => void);
};

export const stopLocationSmart = () => {
	if (updateCallback) {
		eventStream.off(EVENTS.update, updateCallback as unknown as () => void);
		updateCallback = null;
	}
	eventStream.emit(EVENTS.stop);
};
